import { type IconName, UiIconComponent } from '@/ui/icon/ui-icon';
import { UiSectionContentComponent } from '@/ui/section/section-content/ui-section-content';
import { UiSectionComponent } from '@/ui/section/ui-section';
import { ChangeDetectionStrategy, Component, computed, output, signal } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
    type AdvizeoModalButton,
    type AdvizeoModalComponent,
    injectAdvizeoModalInput
} from '../../components/advizeo-modal-spawner/advizeo-modal-spawner.component';

export interface UiChoiceModalInput<T> {
    title: string;
    subTitle?: string;
    buttons: UiChoiceModalButtonInput<T>[];
}

interface UiChoiceModalButtonInput<T> {
    text: string;
    iconName?: IconName;
    code: T;
}

@UntilDestroy()
@Component({
    styleUrls: ['./ui-choice-modal.component.scss'],
    selector: 'ui-choice-modal',
    templateUrl: './ui-choice-modal.component.html',
    imports: [UiSectionComponent, UiSectionContentComponent, UiIconComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiChoiceModalComponent<T> implements AdvizeoModalComponent<UiChoiceModalInput<T>, T> {
    isDismissable = signal(true);
    buttons = signal<AdvizeoModalButton[]>([]);

    input = injectAdvizeoModalInput<UiChoiceModalInput<T>>();
    close = output<T extends null | undefined ? void : T | void | undefined>();

    title = computed(() => this.input().title);
    subtitle = computed(() => this.input().subTitle);

    dismiss() {
        this.close.emit(undefined as T extends null | undefined ? void : T | void | undefined);
    }

    submit(choice: T) {
        {
            this.close.emit(choice as T extends null | undefined ? void : T | void | undefined);
        }
    }
}
